<template>
  <div>
    <div class='wrapper'>
      <div v-for='user in users' :key='user.username' :backgroundcolor='user.color'>
        <div class='site' :style="{backgroundColor: user.color}">
          <p>{{ user.last }}</p>
          <p>{{ user.first }}</p>
          <p>{{ user.role }}</p>
          <a v-if="mayDelete(user)" @click='deleteUser(user)'>Delete</a>
        </div>
      </div>
      <UserForm/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserForm from '@/components/User/UserForm.vue'

export default {
  name: 'User',
  computed: {
    ...mapGetters(['users', 'search'])
  },
  components: {
    UserForm
  },
  created () {
    this.$store.dispatch('getUsers', this.$route.params.id)
  },
  methods: {
    deleteUser (user) {
      var thisUser = { siteid: this.$route.params.siteid, username: user.username }
      this.$store.dispatch('deleteUser', thisUser)
    },
    mayDelete (user) {
      return !user.username.startsWith('!')
    }
  }
}
</script>

<style scoped>
.site {
  border: 3px solid;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.site p:first-child {
  font-weight: bold;
  font-size: 2.5rem;
  margin: 1rem 0;
}

.site p:last-child {
  font-style: italic;
  font-size: 0.8rem;
}
</style>
